import React, { useState, useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import stripeService from '../services/stripeService';
import UpdatePaymentMethodModal from './UpdatePaymentMethodModal';

const UpdatePaymentMethodModalWrapper = (props) => {
  const [stripePromise, setStripePromise] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initializeStripe = async () => {
      if (!props.isOpen) return;
      
      try {
        setLoading(true);
        setError(null);
        const stripe = await stripeService.initialize();
        setStripePromise(stripe);
      } catch (err) {
        console.error('Error initializing Stripe:', err);
        setError('Impossible de charger Stripe. Veuillez réessayer.');
      } finally {
        setLoading(false);
      }
    };

    if (props.isOpen && !stripePromise) {
      initializeStripe();
    }
  }, [props.isOpen, stripePromise]);

  // Si le modal n'est pas ouvert, ne rien afficher
  if (!props.isOpen) {
    return null;
  }

  // Afficher le chargement
  if (loading || !stripePromise) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6">
          <div className="flex items-center">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mr-2"></div>
            <span>Initialisation du système de paiement...</span>
          </div>
        </div>
      </div>
    );
  }

  // Afficher l'erreur
  if (error) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg p-6 max-w-md">
          <h3 className="text-lg font-semibold text-red-600 mb-2">Erreur de chargement</h3>
          <p className="text-gray-700 mb-4">{error}</p>
          <button
            onClick={props.onClose}
            className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Fermer
          </button>
        </div>
      </div>
    );
  }

  // Afficher le modal avec Stripe initialisé
  return (
    <Elements stripe={stripePromise}>
      <UpdatePaymentMethodModal {...props} />
    </Elements>
  );
};

export default UpdatePaymentMethodModalWrapper;
